<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="workbench-approval-main">
      <div class="top-title">当前审批进度</div>
      <div class="approval-result-box">
        <div style="width: 180px;display: flex;justify-content: space-between;">
          <div>
            <div style="font-size: 12px;color: #97A8BE;">提交人</div>
            <div>{{workData.sponsorAccountName}}</div>
            <div>{{workData.createTime}}</div>
          </div>
          <div style="border: 1px solid #D7D7D7;height: 28px;margin: 15px 0;"></div>
        </div>

        <div v-for="item in workData.list">
          <!--审批通过-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.status === '2'">
            <div>
              <i class="iconfont el-icon-damai-shenpitongguo" style="color: #4FB07B;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #009933">审批通过</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.sponsorAccountName}}</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.createTime}}</div>
              <div style="font-size: 12px;color: #97A8BE;width: 240px;">审批意见：{{item.approveResult || '无'}}</div>
            </div>
          </div>

          <!--审批中-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.status === '1'">
            <div>
              <i class="iconfont el-icon-damai-shenpizhong" style="color: #F9A742;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #F9A742">审批中</div>
              <div style="font-size: 12px;color: #97A8BE;line-height: 40px;">{{item.sponsorAccountName}}</div>
            </div>
          </div>

          <!--审批驳回-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.status === '3'">
            <div>
              <i class="iconfont el-icon-damai-shenpibohui" style="color: #D81E06;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #D81E06">审批驳回</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.sponsorAccountName}}</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.createTime}}</div>
              <div style="font-size: 12px;color: #97A8BE;width: 240px;">审批意见：{{item.approveResult || '无'}}</div>
            </div>
          </div>
        </div>

      </div>

      <div class="top-title">审批详情</div>
      <div class="approval-detail-box">
        <!--季度数据-->
        <el-tabs type="card" v-if="workData.uploadDataType === '1'" v-model="activeName">
          <el-tab-pane name="园区信息" label="园区信息">
            <div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">园区剩余可租面积：</span>
                </div>
                <el-input v-model="formData.rentArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">园区剩余可售面积：</span>
                </div>
                <el-input v-model="formData.saleArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">已出售面积：</span>
                </div>
                <el-input v-model="formData.soldArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">已出租面积：</span>
                </div>
                <el-input v-model="formData.rentedArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="企业信息" label="企业信息">
            <div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">入驻企业总数：</span>
                </div>
                <el-input v-model="formData.companyNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">家</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">入驻企业员工总数：</span>
                </div>
                <el-input v-model="formData.allEmployeeNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">人</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">入驻企业营业总收入：</span>
                </div>
                <el-input v-model="formData.allRevenueTotal" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">本年度累计安全生产事故数：</span>
                </div>
                <el-input v-model="formData.allSafetyEvent" size="small" style="width: 280px" disabled>
                  <template slot="append">件</template>
                </el-input>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="能耗计量" label="能耗计量">
            <div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">用电量本期值：</span>
                </div>
                <el-input v-model="formData.electricityData" size="small" style="width: 280px" disabled>
                  <template slot="append">千瓦时</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第1个月用电量本期值：</span>
                </div>
                <el-input v-model="formData.currentElectricityFirstMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">千瓦时</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第2个月用电量本期值：</span>
                </div>
                <el-input v-model="formData.currentElectricitySecondMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">千瓦时</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第3个月用电量本期值：</span>
                </div>
                <el-input v-model="formData.currentElectricityThirdMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">千瓦时</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">用水量本期值：</span>
                </div>
                <el-input v-model="formData.waterData" size="small" style="width: 280px" disabled>
                  <template slot="append">吨</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第1个月用水量本期值：</span>
                </div>
                <el-input v-model="formData.currentWaterFirstMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">吨</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第2个月用水量本期值：</span>
                </div>
                <el-input v-model="formData.currentWaterSecondMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">吨</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第3个月用水量本期值：</span>
                </div>
                <el-input v-model="formData.currentWaterThirdMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">吨</template>
                </el-input>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="党群信息" label="党群信息">
            <div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中党员人数：</span>
                </div>
                <el-input v-model="formData.partyNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">人</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">是否有党组织：</span>
                </div>
                <el-select v-model="formData.partyBranch" placeholder="请选择" size="mini" style="width: 280px" disabled>
                  <el-option
                    v-for="item in partyBranchList"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!--年度数据-->
        <el-tabs type="card" v-if="workData.uploadDataType === '2'" v-model="activeName">
          <el-tab-pane name="园区信息" label="园区信息">
            <div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">实际用地面积：</span>
                </div>
                <el-input v-model="formData.coverArea" size="small" style="width: 280px" disabled>
                  <template slot="append">亩</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">已建建筑面积：</span>
                </div>
                <el-input v-model="formData.buildArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">已建公共配套设施建筑面积：</span>
                </div>
                <el-input v-model="formData.pubCmptStrArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">园区剩余可租面积：</span>
                </div>
                <el-input v-model="formData.rentArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">园区剩余可售面积：</span>
                </div>
                <el-input v-model="formData.saleArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">已出售面积：</span>
                </div>
                <el-input v-model="formData.soldArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">已出租面积：</span>
                </div>
                <el-input v-model="formData.rentedArea" size="small" style="width: 280px" disabled>
                  <template slot="append">平方米</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">当前每平方米平均租金：</span>
                </div>
                <el-input v-model="formData.rentAmt" size="small" style="width: 280px" disabled>
                  <template slot="append">元/天</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">前每平方米平均售价：</span>
                </div>
                <el-input v-model="formData.sellMetre" size="small" style="width: 280px" disabled>
                  <template slot="append">元</template>
                </el-input>
              </div>

              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">园区获得各级政府支持的金额：</span>
                </div>
                <el-input v-model="formData.settledEntReceiveGovSupport" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">园区或园内企业获得省级以上荣誉或奖项情况：</span>
                </div>
                <el-input v-model="formData.gardenAwards" size="small" style="width: 280px" disabled/>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">本年度累计安全生产事故数：</span>
                </div>
                <el-input v-model="formData.allSafetyEvent" size="small" style="width: 280px" disabled>
                  <template slot="append">件</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">监控设备调用频次：</span>
                </div>
                <el-input v-model="formData.callingFrequency" size="small" style="width: 280px" disabled>
                  <template slot="append">件</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">使用时间范围：</span>
                </div>
                <el-select v-model="formData.timeRange" placeholder="请选择" size="mini" style="width: 280px" disabled>
                  <el-option
                    v-for="item in timeRangeList"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="企业信息" label="企业信息">
            <div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">入驻企业总数：</span>
                </div>
                <el-input v-model="formData.companyNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">家</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">规模以上企业数：</span>
                </div>
                <el-input v-model="formData.scaleNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">家</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">高新技术企业数：</span>
                </div>
                <el-input v-model="formData.techNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">家</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">科技型中小企业数：</span>
                </div>
                <el-input v-model="formData.sciNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">家</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">隐形冠军企业数：</span>
                </div>
                <el-input v-model="formData.champion" size="small" style="width: 280px" disabled>
                  <template slot="append">家</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">精特新"小巨人"企业：</span>
                </div>
                <el-input v-model="formData.specializedAndNewEntNum" size="small" style="width: 280px" disabled>
                  <template slot="append">家</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">上市（挂牌）企业数：</span>
                </div>
                <el-input v-model="formData.listNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">家</template>
                </el-input>
              </div>

              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">入驻企业员工总数：</span>
                </div>
                <el-input v-model="formData.allEmployeeNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">人</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中"国千"人才：</span>
                </div>
                <el-input v-model="formData.allGqNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">人</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中"省千"人才：</span>
                </div>
                <el-input v-model="formData.allSqNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">人</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中正高级工程师人数：</span>
                </div>
                <el-input v-model="formData.allProofengineerNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">人</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中高级工程师人数：</span>
                </div>
                <el-input v-model="formData.allSenniorengineerNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">人</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中高级技师人数：</span>
                </div>
                <el-input v-model="formData.allSeniortechnicianNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">人</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中硕士以上人数：</span>
                </div>
                <el-input v-model="formData.allMasterNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">人</template>
                </el-input>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="产值投资" label="产值投资">
            <div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">入驻企业税收累计值：</span>
                </div>
                <el-input v-model="formData.allTaxTotal" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">入驻企业营业总收入：</span>
                </div>
                <el-input v-model="formData.allRevenueTotal" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">入驻企业利润总额累计值：</span>
                </div>
                <el-input v-model="formData.allProfitTotal" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">减免入驻企业租金金额：</span>
                </div>
                <el-input v-model="formData.taxReductionTotal" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">专利拥有量：</span>
                </div>
                <el-input v-model="formData.allPatentNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">件</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中发明专利：</span>
                </div>
                <el-input v-model="formData.allFmlNumber" size="small" style="width: 280px" disabled>
                  <template slot="append">件</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">实用新型专利：</span>
                </div>
                <el-input v-model="formData.utilityModelPatent" size="small" style="width: 280px" disabled>
                  <template slot="append">件</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">外观设计专利：</span>
                </div>
                <el-input v-model="formData.industrialDesignPatent" size="small" style="width: 280px" disabled>
                  <template slot="append">件</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">已完成投资额：</span>
                </div>
                <el-input v-model="formData.finishedInvestment" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中国有投资额：</span>
                </div>
                <el-input v-model="formData.govInvestment" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中集体投资额：</span>
                </div>
                <el-input v-model="formData.groupInvestment" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中民营投资额：</span>
                </div>
                <el-input v-model="formData.privateInvestment" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中其他投资额：</span>
                </div>
                <el-input v-model="formData.otherInvestment" size="small" style="width: 280px" disabled>
                  <template slot="append">万元</template>
                </el-input>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="能耗计量" label="能耗计量">
            <div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">用电量本期值：</span>
                </div>
                <el-input v-model="formData.electricityData" size="small" style="width: 280px" disabled>
                  <template slot="append">千瓦时</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第1个月用电量本期值：</span>
                </div>
                <el-input v-model="formData.currentElectricityFirstMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">千瓦时</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第2个月用电量本期值：</span>
                </div>
                <el-input v-model="formData.currentElectricitySecondMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">千瓦时</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第3个月用电量本期值：</span>
                </div>
                <el-input v-model="formData.currentElectricityThirdMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">千瓦时</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">用水量本期值：</span>
                </div>
                <el-input v-model="formData.waterData" size="small" style="width: 280px" disabled>
                  <template slot="append">吨</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第1个月用水量本期值：</span>
                </div>
                <el-input v-model="formData.currentWaterFirstMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">吨</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第2个月用水量本期值：</span>
                </div>
                <el-input v-model="formData.currentWaterSecondMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">吨</template>
                </el-input>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中第3个月用水量本期值：</span>
                </div>
                <el-input v-model="formData.currentWaterThirdMonth" size="small" style="width: 280px" disabled>
                  <template slot="append">吨</template>
                </el-input>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="党群服务" label="党群服务">
            <div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中党委：</span>
                </div>
                <el-input v-model="formData.partyCommitteeNum" size="small" style="width: 280px" disabled/>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中党总支：</span>
                </div>
                <el-input v-model="formData.generalPartyBranchNum" size="small" style="width: 280px" disabled/>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中党支部：</span>
                </div>
                <el-input v-model="formData.partyBranchNum" size="small" style="width: 280px" disabled/>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">其中党员人数：</span>
                </div>
                <el-input v-model="formData.partyNumber" size="small" style="width: 280px" disabled/>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">是否有党组织：</span>
                </div>
                <el-select v-model="formData.partyBranch" placeholder="请选择" size="mini" style="width: 280px" disabled>
                  <el-option
                    v-for="item in partyBranchList"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key">
                  </el-option>
                </el-select>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">服务活动场次：</span>
                </div>
                <el-input v-model="formData.serveActivityCount" size="small" style="width: 280px" disabled/>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">服务企业家次数：</span>
                </div>
                <el-input v-model="formData.serveEntCount" size="small" style="width: 280px" disabled/>
              </div>
              <div class="form-line">
                <div class="textBox">
                  <span class="line-text">服务人次：</span>
                </div>
                <el-input v-model="formData.servePeopleCount" size="small" style="width: 280px" disabled/>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>


      <div class="operationBox">
<!--        <button-cancel value="撤回" v-if="workType === 'sponsored' && workData.contractApproveChainStatuses[workData.contractApproveChainStatuses.length -1].approveStatus === '0'" @cancel="recallContract" />-->
        <el-button size="small" class="btn-confirm" v-if="workType === 'pendingApproval'" @click="confirmApprove()">同意</el-button>
        <el-button size="small" class="reject-button" v-if="workType === 'pendingApproval'" @click="rejectApprove()" >驳回</el-button>
        <button-cancel value="返回" @cancel="toWorkbenchApprovalPage" />
      </div>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="memo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="passSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="approveRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="rejectMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelReject">取 消</el-button>
          <el-button size="small" type="primary" @click="unpassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonAdd from '../../../components/common/buttons/button-add'
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../api/WorkbenchApproval'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      ButtonConfirm,
      ButtonAdd,
      ButtonCancel,
      Breadcrumb},
    name: 'political-communication-approval-detail',
    data () {
      return {
        breadcrumb: [{
          value: '工作台',
          name: 'workbench'
        }, {
          value: '审批详情'
        }],
        approveDialog: false,
        approveRejectDialog: false,
        workData: {},
        workType: '', // sponsored-我发起的  pendingApproval-待我审批  approved-我已审批
        activeName: '园区信息',
        accountCode: '',
        accountName: '',

        timeRangeList: [
          {key: '0', label: '工作日'},
          {key: '1', label: '全天'},
        ],
        partyBranchList: [
          {key: '0', label: '否'},
          {key: '1', label: '是'},
        ],
        formData: {},
        memo: '',
        rejectMemo: '',
        approveAccountCode: '',
        rentRefundAgreementData: {
          contractSurrenderDetails: [],
          surrenderReasonArr: []
        },
      }
    },
    created () {
      this.workData = jQuery.parseJSON(sessionStorage.getItem('politicalCommunicationDetailData'))
      this.workType = sessionStorage.getItem('politicalCommunicationDetailActiveName')
      this.accountCode = bus.global.accountCode
      this.accountName = bus.global.accountName
      this.getUploadParam()
    },
    methods: {
      // 跳转我的工作台
      toWorkbenchApprovalPage () {
        this.$router.back(-1)
      },

      // 获取信息
      getUploadParam () {
        this.$axios.post(`${api.getUploadParam}`, {
          uploadDataCode: this.workData.uploadDataCode,
          uploadDataType: this.workData.uploadDataType,
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.formData = data
            }
          })
          .catch(errorHandler('查询信息失败'))
      },

      // 撤回审批
      recallContract () {
        this.$confirm('是否确认撤回审批？', '提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.recallContract, {
              approveType: this.workData.approveType,
              contractCode: this.workData.contractCode
            })
              .then(res => {
                if (res.data.retCode === 1) {
                  nSuccess('审批已撤回')
                  this.toWorkbenchApprovalPage()
                }
              })
              .catch(errorHandler('审批撤回失败'))
          })
          .catch(() => {
            console.log()
          })
      },

      // 审批通过输入意见
      confirmApprove () {
        this.approveDialog = true
      },

      // 审批驳回输入意见
      rejectApprove () {
        this.approveRejectDialog = true
      },

      // 取消审批通过
      cancelApprove () {
        this.memo = ''
        this.approveDialog = false
      },

      // 审批通过
      passSubmit () {
        let idx = this.workData.list.length - 1
        let code = this.workData.list[idx].code
        this.$axios.post(api.consentApproveChain, {
          code,
          approveResult: this.memo,
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('审批已通过')
              this.memo = ''
              this.toWorkbenchApprovalPage()
            }
          })
          .catch(errorHandler('审批通过失败'))
      },

      // 取消审批驳回
      cancelReject () {
        this.rejectMemo = ''
        this.approveRejectDialog = false
      },

      // 审批驳回
      unpassSubmit () {
        let idx = this.workData.list.length - 1
        let code = this.workData.list[idx].code
        this.$axios.post(api.rejectApproveChain, {
          code,
          approveResult: this.rejectMemo,
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('审批已驳回')
              this.rejectMemo = ''
              this.toWorkbenchApprovalPage()
            }
          })
          .catch(errorHandler('审批通过失败'))
      },
    }
  }
</script>

<style scoped>
  .workbench-approval {
    text-align: left;
  }
  .workbench-approval-main {
    padding: 0 10px;
  }
  .top-title {
    color: #48576A;
    margin: 25px 0 10px 0;
    padding-left: 5px;
    font-size: 16px;
    line-height: 28px;
    border-left: 3px solid #00A0E6;
  }
  .approval-result-box {
    padding: 10px 30px;
    border-radius: 9px;
    color: #48576A;
    border: 1px solid #D7D7D7;
    display: flex;
    line-height: 20px;
    justify-content: flex-start;
    align-items: center;
  }
  form {
    width: 100%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-title {
    color: #333333;
    font-size: 16px;
    line-height: 24px;
    padding-left: 5px;
    margin-top: 5px;
    border-left: 3px solid #00a0e6;
  }
  .form-line {
    margin: 10px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
  }
  .textBox {
    display: inline-block;
    width: 240px;
    min-width: 145px;
    line-height: 32px;
    text-align: right;
  }

  .form-btn-box {
    margin: 30px auto;
    display: flex;
    justify-content: flex-end;
  }
</style>

<style lang="less">
  .workbench-approval {
    .el-tabs__active-bar {
      width: 96px!important;
    }
    .el-tabs--top {
      height: 100%;
      .is-top:nth-child(2) {
        padding-left: 20px!important;
      }
      #tab-rentTerms {
        /*margin: 0 0 0 20px;*/
      }
      .is-top:last-child {
        padding-left: 0;
        .el-tabs__item {
          padding: 0 20px;
        }
      }
      .el-tabs__nav-wrap::after {
        height: 1px;
      }
    }

    .approval-detail-box {
      padding: 20px 10px;
      .el-tabs__content {
        padding-bottom: 20px;
      }
    }

    .btn-confirm {
      border: 0;
      color: #FFF;
      padding: 8px 16px;
      background-color: #00a0e6;
      border-radius: 4px;
    }
    .btn-confirm:hover {
      color: #FFF;
      background-color: #06b3ff;
    }

    .operationBox {
      display: flex;
      justify-content: flex-end;
      border-radius: 4px;
      .reject-button {
        background-color: #f25721;
        color: #FFFFFF;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/PendingItems/PoliticalCommunicationApproval/PoliticalCommunicationApprovalDetail.vue